import './location_picker.scss';

export const LocationPickerComponent = {
    template: `
        <geo-autocomplete
            ng-if="!$ctrl.loading"
            initial-address="$ctrl.initialAddress"
            stored-addresses="$ctrl.savedAddresses"
            on-geolocation-error="$ctrl.onGeolocationError(error)"
            on-address-selection="$ctrl.onAddressSelection(address)"></geo-autocomplete>
        <oo-alert ng-if="$ctrl.errorMessage" severity="warning">
            <oo-alert-message>{{$ctrl.errorMessage}}</oo-alert-message>
        </oo-alert>
    `,
    controller: class {
        constructor(accountService, featureFlagService, googleAnalyticsTrackingService, locationService, orderInfoService) {
            'ngInject';
            this.accountService = accountService;
            this.featureFlagService = featureFlagService;
            this.googleAnalyticsTrackingService = googleAnalyticsTrackingService;
            this.locationService = locationService;
            this.orderInfoService = orderInfoService;
        }

        $onInit() {
            this.accountService.getAddresses()
                .then(() => this._getSavedAddresses())
                .finally(() => this.loading = false);
            this._setInitialAddress();
            this.loading = true;
        }


        _setInitialAddress() {
            let savedInfo = this.orderInfoService.getDeliveryInfo();
            if(!!savedInfo.latitude && !!savedInfo.longitude) {
                this.initialAddress = this.orderInfoService.transformAddress(savedInfo);
                this.initialAddress.isSavedAddress = true;
            }
        }

        _getSavedAddresses() {
            let addresses = this.accountService.data.addresses;
            this.savedAddresses = addresses.map(a => {
                let addr = Object.assign({}, a);
                addr.description = `${a.name}: ${a.address1}`;
                addr.isSavedAddress = true;
                return addr;
            });
        }

        onAddressSelection(address) {
            this.errorMessage = null;
            address.streetAddress1 = address.address1;
            address.streetAddress2 = address.streetAddress2;
            this.orderInfoService.setDeliveryInfoData(address);
            this.locationService.verifyDeliveryRange(address.latitude, address.longitude)
                .then(
                    () => this.googleAnalyticsTrackingService.trackVerifyAddress(),
                    err => this.onGeolocationError(err)
                );
        }

        onGeolocationError(error) {
            if (!error || !error.message) error = { message: 'We are unable to deliver to this address.' };
            this.errorMessage = error.message;

            this.googleAnalyticsTrackingService.trackVerifyAddress(this.errorMessage);
        }
    }
};
